import { render, staticRenderFns } from "./NotificationInvoiceRemove.vue?vue&type=template&id=68e48dfc&scoped=true&"
import script from "./NotificationInvoiceRemove.vue?vue&type=script&lang=js&"
export * from "./NotificationInvoiceRemove.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInvoiceRemove.vue?vue&type=style&index=0&id=68e48dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e48dfc",
  null
  
)

export default component.exports